const { useState, useEffect } = require("react");

function useFetcher(initUrl) {
    const [title, setTitle] = useState('now_playing');
    const [url, setUrl] = useState(initUrl)
    const [data, setData] = useState()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {      
        fetch(url)
        .then((response) => response.json())
        .then((res) => {
            if(Array.isArray(res.results) || res.hasOwnProperty('id')){
                setData(res)
            } else {
                throw new Error('Not Found')
            }
        })
        .catch((err) => {
            setError(err)
        })
        .finally(() => {
            setLoading(false)
        })
    }, [url]);

    function changeCategory(category){
        setUrl(`https://api.themoviedb.org/3/movie/${category}?api_key=${process.env.REACT_APP_API_KEY}&language=en-US&page=1`)
        setTitle(category)
    }

    return { title, data, loading, error, changeCategory };
}

export default useFetcher;